import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { About } from './pages/about/about';
import { Contact } from './pages/contact/contact';

// Performance Marketing
import { PerformanceMarketing } from './pages/performance-marketing/performance-marketing';
import { PaidAds } from './pages/performance-marketing/paid-ads';
import { AnalyticsComponent as Analytics } from './pages/performance-marketing/analytics';
import { CroComponent as Cro } from './pages/performance-marketing/cro';
import { SeoComponent as Seo } from './pages/performance-marketing/seo';
import { AutomationComponent as Automation } from './pages/performance-marketing/automation';
import { LeadGenerationComponent as LeadGeneration } from './pages/performance-marketing/lead-generation';
import { SocialMediaComponent as SocialMedia } from './pages/performance-marketing/social-media';

// Cloud Compliance
import { CloudCompliance } from './pages/cloud-compliance/cloud-compliance';
import { Pci } from './pages/cloud-compliance/pci';
import { Soc2 } from './pages/cloud-compliance/soc2';
import { Hipaa } from './pages/cloud-compliance/hipaa';
import { Iso27001 } from './pages/cloud-compliance/iso27001';
import { Gdpr } from './pages/cloud-compliance/gdpr';

// DevOps
import { Devops } from './pages/devops/devops';
import { Cicd } from './pages/devops/cicd';
import { Iac } from './pages/devops/iac';
import { Containers } from './pages/devops/containers';
import { Devsecops } from './pages/devops/devsecops';
import { Monitoring } from './pages/devops/monitoring';
import { Finops } from './pages/devops/finops';

// Messaging
import { Messaging } from './pages/messaging/messaging';
import { BulkSms } from './pages/messaging/bulk-sms';
import { BulkEmail } from './pages/messaging/bulk-email';
import { BulkWhatsapp } from './pages/messaging/bulk-whatsapp';
import { Rcs } from './pages/messaging/rcs';
import { WhatsappApi } from './pages/messaging/whatsapp-api';

// Legal
import { PrivacyPolicyComponent as PrivacyPolicy } from './pages/legal/privacy-policy';
import { TermsComponent as Terms } from './pages/legal/terms';

// Landing
import { Landing } from './pages/landing/landing';

// Blog
import { Blog } from './pages/blog/blog';
import { BlogDetailComponent } from './pages/blog-detail/blog-detail';

export const routes: Routes = [
  { path: '', component: Home },
  { path: 'about', component: About },
  { path: 'contact', component: Contact },

  // Performance Marketing routes
  { path: 'performance-marketing', component: PerformanceMarketing },
  { path: 'performance-marketing/paid-ads', component: PaidAds },
  { path: 'performance-marketing/analytics', component: Analytics },
  { path: 'performance-marketing/cro', component: Cro },
  { path: 'performance-marketing/seo', component: Seo },
  { path: 'performance-marketing/automation', component: Automation },
  { path: 'performance-marketing/lead-generation', component: LeadGeneration },
  { path: 'performance-marketing/social-media', component: SocialMedia },

  // Cloud Compliance routes
  { path: 'cloud-compliance', component: CloudCompliance },
  { path: 'cloud-compliance/pci', component: Pci },
  { path: 'cloud-compliance/soc2', component: Soc2 },
  { path: 'cloud-compliance/hipaa', component: Hipaa },
  { path: 'cloud-compliance/iso27001', component: Iso27001 },
  { path: 'cloud-compliance/gdpr', component: Gdpr },

  // DevOps routes
  { path: 'devops', component: Devops },
  { path: 'devops/cicd', component: Cicd },
  { path: 'devops/iac', component: Iac },
  { path: 'devops/containers', component: Containers },
  { path: 'devops/devsecops', component: Devsecops },
  { path: 'devops/monitoring', component: Monitoring },
  { path: 'devops/finops', component: Finops },

  // Messaging routes
  { path: 'messaging', component: Messaging },
  { path: 'messaging/bulk-sms', component: BulkSms },
  { path: 'messaging/bulk-email', component: BulkEmail },
  { path: 'messaging/bulk-whatsapp', component: BulkWhatsapp },
  { path: 'messaging/rcs', component: Rcs },
  { path: 'messaging/whatsapp-api', component: WhatsappApi },

  // Legal routes
  { path: 'privacy-policy', component: PrivacyPolicy },
  { path: 'terms', component: Terms },

  // Landing route
  { path: 'landing', component: Landing },

  // Blog routes
  { path: 'blog', component: Blog },
  { path: 'blog/:slug', component: BlogDetailComponent },

  { path: '**', redirectTo: '' }
];
